import { render, staticRenderFns } from "./ProductCategoryCard.vue?vue&type=template&id=60301ce2&scoped=true"
import script from "./ProductCategoryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCategoryCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProductCategoryCard.vue?vue&type=style&index=0&id=60301ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60301ce2",
  null
  
)

export default component.exports